import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
Vue.use(VueRouter);
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const constantRoutes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404/index.vue"),
  },
  {
    path: "/home",
    name: "Home", //home是登录之后的整个首页
    component: () => import("../views/Home.vue"),
    //  redirect: "homepage"
    children: [
      // 首页默认二级页面
      {
        path: "/",
        redirect: "homepage",
      },
      // // 首页
      // {
      //     path: "homepage",
      //     name: "HomePage",//homepage是导航栏中的首页
      //     component: () =>
      //         import ("../views/HomePage/index.vue"),
      //      meta: {
      //         title: '首页',
      //         roles: ['admin', 'editor']
      //         },
      // },
    ],
  },
  // 打印
  {
    path: "/print",
    name: "print",
    component: () => import("../views/case/print.vue"),
    meta: {
      title: "打印",
      roles: ["admin", "editor"], // you can set roles in root nav
    },
    hidden: true,
  },
   
];
export const asyncRoutes = [

  //首页
  {
    path: "homePage",
    name: "homePage", //homepage是导航栏中的首页
    redirect: "/home/homePage/firstPage",
    component: () => import("../views/HomePage/index.vue"),
    meta: {
      title: "首页",
      roles: ["admin", "editor"],
    },
    children: [
      // // 案例默认三级页面
      // {
      //     path: "/",
      //     redirect: "firstpage"
      // },
      // 首页
      {
        path: "firstPage",
        name: "firstPage",
        component: () => import("../views/HomePage/firstpage.vue"),
        meta: {
          title: "首页",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      // 审批通知
      {
        path: "noticePage",
        name: "noticePage",
        component: () => import("../views/HomePage/notice.vue"),
        meta: {
          title: "审批通知",
          roles: ["admin"], // you can set roles in root nav
        },
      },
    ],
  },

  //利益冲突检索
  {
    path: "conflict",
    name: "conflict",
    component: () => import("../views/conflict/index.vue"),
    meta: {
      title: "利益冲突检索",
      roles: ["admin", "editor"],
      keepAlive: true
    },
    redirect: "/home/conflict/conflictSearch",
    children: [
      // 案件冲突
      {
        path: "conflictCase",
        name: "conflictCase",
        component: () => import("../views/conflict/conflictCase.vue"),
        meta: {
          title: "全部冲突",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: true
        },
      },
      // 顾问冲突
      // {
      //   path: "conflictCounsel",
      //   name: "conflictCounsel",
      //   component: () => import("../views/conflict/conflictCounsel.vue"),
      //   meta: {
      //     title: "顾问冲突",
      //     roles: ["admin", "editor"], // you can set roles in root nav
      //   },
      // },
    ],
  },

  //审批
  {
    path: "examine",
    name: "examine",
    component: () => import("../views/examine/index.vue"),
    meta: {
      title: "审批",
      roles: ["admin", "editor"],
    },
    redirect: "/home/examine/Caseapprove",
    children: [
      {
        path: "Caseapprove",
        name: "Caseapprove",
        component: () => import("../views/examine/Caseapprove.vue"),
        meta: {
          title: "案件审批",
          roles: ["admin", "editor"], // you can set roles in root nav
          hidden: false,
        },
      },
      {
        path: "CaseRecord",
        name: "CaseRecord",
        component: () => import("../views/examine/CaseRecord.vue"),
        meta: {
          title: "案件审批记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          hidden: false,
        },
      },

      {
        path: "Casedetail",
        name: "Casedetail",
        component: () => import("../views/examine/Casedetail.vue"),
        meta: {
          title: "案件详情",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
        hidden: true,
      },

    ],
  },

  //案件管理
  {
    path: "case",
    name: "case",
    component: () => import("../views/case/index.vue"),
    meta: {
      title: "案件管理",
      roles: ["admin", "editor"], // you can set roles in root nav
    },
    redirect: "/home/case/myCase",
    children: [
      
      // 我的案例
      {
        path: "myCase",
        name: "myCase",
        component: () => import("../views/case/my.vue"),
        meta: {
          title: "我的案件",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
      },

      // 案件子组件
      {
        path: "commitCase",
        name: "commitCase",
        component: () => import("../views/case/Commit.vue"),
        meta: {
          title: "案件子组件",
          roles: ["admin"], // you can set roles in root nav
          keepAlive: false // 需要缓存
        },
        hidden: true,
      },
      // 所有的案例
      {
        path: "allCase",
        name: "allCase",
        component: () => import("../views/case/All.vue"),
        meta: {
          title: "全部案件",
          roles: ["admin"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
      },
    
      {
        path: "filedCase",
        name: "filedCase",
        component: () => import("../views/case/filed.vue"),
        meta: {
          title: "已归档案件",
          roles: ["editor", "admin"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
      },
      {
        path: "AllBankruptCase",
        name: "AllBankruptCase",
        component: () => import("../views/case/AllBankruptCase.vue"),
        meta: {
          title: "全部破产案件",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
      },
      {
        path: "caseinput",
        name: "caseinput",
        component: () => import("../views/case/caseinput.vue"),
        meta: {
          title: "案件录入",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: false 
        },
        hidden: true,
      },

      {
        path: "caseinfo",
        name: "caseinfo",
        component: () => import("../views/case/caseinfo.vue"),
        meta: {
          title: "案件信息",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: false 
        },
        hidden: true,
      },

      {
        path: "casetext",
        name: "casetext",
        component: () => import("../views/case/casetext.vue"),
        meta: {
          title: "案件文档",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: false 
        },
        hidden: true,
      },
      {
        path: "bankinput",
        name: "bankinput",
        component: () => import("../views/bankrupt/bankinput.vue"),
        meta: {
          title: "破产案件录入",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "bankrupt",
        },
        hidden: true,
      },
      {
        path: "Bidinput",
        name: "Bidinput",
        component: () => import("../views/bankrupt/Bidinput.vue"),
        meta: {
          title: "破产案件投标录入",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "bankrupt",
        },
        hidden: true,
      },
      {
        path: "bankruptdetail",
        name: "bankruptdetail",
        component: () => import("../views/bankrupt/detail.vue"),
        meta: {
          title: "案件信息",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu:'detail',
        },
        hidden: true,
      },
      {
        path: "bankruptfile",
        name: "bankruptfile",
        component: () => import("../views/bankrupt/file.vue"),
        meta: {
          title: "案件文档",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu:'detail',
        },
        hidden: true,
      },
    ],
  },

  //法律顾问
  {
    path: "counsel",
    name: "counsel",
    component: () => import("../views/counsel/index.vue"),
    meta: {
      title: "法律顾问",
      roles: ["admin", "editor"],
    },
    redirect: "/home/counsel/legalCounsel",
    children: [
      // 法律顾问
      {
        path: "legalCounsel",
        name: "legalCounsel",
        component: () => import("../views/counsel/legalCounsel.vue"),
        meta: {
          title: "法律顾问",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      // 所有顾问
      {
        path: "allCounsel",
        name: "allCounsel",
        component: () => import("../views/counsel/AllCounsel.vue"),
        meta: {
          title: "所有顾问",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
    ],
  },

  //破产管理人
  {
    path: "bankruptcy",
    name: "bankruptcy",
    component: () => import("../views/bankruptcy/index.vue"),
    meta: {
      title: "破产管理人",
      roles: ["admin", "editor"],
      keepAlive: true
    },
    redirect: "/home/bankruptcy/bankruptcyManagerInfo",
    children: [
      {
        path: "bankruptcyManagerInfo",
        name: "bankruptcyManagerInfo",
        component: () => import("../views/bankruptcy/bankruptcyManagerInfo.vue"),
        meta: {
          title: "查看",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
      },
      {
        path: "bankruptcyManagerInput",
        name: "bankruptcyManagerInput",
        component: () => import("../views/bankruptcy/bankruptcyManagerInput.vue"),
        meta: {
          title: "录入",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
        hidden: true,
      },{
        path: "bankruptcyManagerCheck",
        name: "bankruptcyManagerCheck",
        component: () => import("../views/bankruptcy/bankruptcyManagerCheck.vue"),
        meta: {
          title: "审批",
          roles: ["admin", "editor"], // you can set roles in root nav
          keepAlive: true // 需要缓存
        },
      },
    ]

  
  },

  //用章申请
  {
    path: "seal",
    name: "seal",
    component: () => import("../views/seal/index.vue"),
    redirect: "/home/seal/sealapprove",
    meta: {
      title: "用章申请",
      roles: ["admin", "editor"],
    },
    children: [
      //添加新的页面写下面，上面的顺序不能动
      {
        path: "SealApprove",
        name: "SealApprove",
        component: () => import("../views/seal/SealApprove.vue"),
        meta: {
          title: "用章审批",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "seal",
        },
        hidden: false,
      },

      {
        path: "SealApprovedetail",
        name: "SealApprovedetail",
        component: () => import("../views/seal/SealApprovedetail.vue"),
        meta: {
          title: "用章审批",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "sealAppdetail",
        },
        hidden: true,
      },
      {
        path: "allCheckSeal",
        name: "allCheckSeal",
        component: () => import("../views/seal/allCheckSeal.vue"),
        meta: {
          title: "用章审批记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "seal",
        },
        hidden: true,
        // hidden: false,
      },
      {
        path: "sealrecord",
        name: "sealrecord",
        component: () => import("../views/seal/sealrecord.vue"),
        meta: {
          title: "用章申请记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "seal",
        },
        // hidden: true,
        hidden: false,
      },
      {
        path: "AllSeal",
        name: "AllSeal",
        component: () => import("../views/seal/AllSeal.vue"),
        meta: {
          title: "全部用章申请记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "seal",
        },
        hidden: false,
      },
      {
        path: "sealApply",
        name: "sealApply",
        component: () => import("../views/seal/sealApply.vue"),
        meta: {
          title: "用章申请",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "seal",
        },
        hidden: true,
      },
     
      {
        path: "Sealdetail",
        name: "Sealdetail",
        component: () => import("../views/seal/Sealdetail.vue"),
        meta: {
          title: "用章详情",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Sealdetail",
        },
        hidden: true,
      },
      {
        path: "BidApprove",
        name: "BidApprove",
        component: () => import("../views/seal/BidApprove.vue"),
        meta: {
          title: "投标审批",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Bid",
        },
        hidden: true,
      },
      {
        path: "allCheckTender",
        name: "allCheckTender",
        component: () => import("../views/seal/allCheckTender.vue"),
        meta: {
          title: "投标审批记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Bid",
        },
        // hidden: false,
        hidden:true
      },
      {
        path: "BidApprovedetail",
        name: "BidApprovedetail",
        component: () => import("../views/seal/BidApprovedetail.vue"),
        meta: {
          title: "投标审批",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "BidAppdetail",
        },
        hidden: true,
      },
      {
        path: "Bidrecord",
        name: "Bidrecord",
        component: () => import("../views/seal/Bidrecord.vue"),
        meta: {
          title: "投标申请记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Bid",
        },
        hidden: true,
      },
      {
        path: "AllBid",
        name: "AllBid",
        component: () => import("../views/seal/AllBid.vue"),
        meta: {
          title: "全部投标申请记录",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Bid",
        },
        hidden: false,
      },
      {
        path: "BidApply",
        name: "BidApply",
        component: () => import("../views/seal/BidApply.vue"),
        meta: {
          title: "审批申请",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Bid",
        },
        hidden: true,
      },
      {
        path: "Biddetail",
        name: "Biddetail",
        component: () => import("../views/seal/Biddetail.vue"),
        meta: {
          title: "投标审批详情",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu: "Biddetail",
        },
        hidden: true,
      },
      
    ],
  },

  //归档
  {
    path: "archive",
    name: "archive",
    component: () => import("../views/archive/index.vue"),
    meta: {
      title: "归档",
      roles: ["admin", "editor"],
    },
    redirect: "/home/archive/archiveManage",
    children: [
      // 归档管理
      {
        path: "archiveManage",
        name: "archiveManage",
        component: () => import("../views/archive/archiveManage.vue"),
        meta: {
          title: "归档管理",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      // 新增确认
      {
        path: "newConfirm",
        name: "newConfirm",
        component: () => import("../views/archive/newConfirm.vue"),
        meta: {
          title: "新增确认",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      //借出管理
      {
        path: "lendManage",
        name: "lendManage",
        component: () => import("../views/archive/lendManage.vue"),
        meta: {
          title: "借出管理",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
    ],
  },

  //公共文档
  {
    path: "documents",
    name: "documents",
    component: () => import("../views/documents/documentsPublic.vue"),
    meta: {
      title: "公共文档",
      roles: ["admin", "editor"],
      keepAlive: false
    },
  },

    //发送通知
    {
      path: "notice",
      name: "notice",
      component: () => import("../views/notice/sendnotice.vue"),
      meta: {
        title: "发送通知",
        roles: ["admin", "editor"],
        keepAlive: false
      },
    },

  //破产案件
  {
    path: "bankrupt",
    name: "bankrupt",
    redirect: "/home/bankrupt/bankruptCase",
    component: () => import("../views/bankrupt/index.vue"),
    meta: {
      title: "破产案件",
      roles: ["admin", "editor"],
    },
    children: [
      {
        path: "bankruptBid",
        name: "bankruptBid",
        component: () => import("../views/bankrupt/Bid.vue"),
        meta: {
          title: "破产案件投标",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      {
        path: "allbankruptBid",
        name: "allbankruptBid",
        component: () => import("../views/bankrupt/AllBid.vue"),
        meta: {
          title: "全部破产案件投标",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      {
        path: "bankruptCase",
        name: "bankruptCase",
        component: () => import("../views/bankrupt/bankrupt.vue"),
        meta: {
          title: "破产案件",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      {
        path: "allbankruptCase",
        name: "allbankruptCase",
        component: () => import("../views/bankrupt/AllBankrupt.vue"),
        meta: {
          title: "全部破产案件",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      {
        path: "bankinput",
        name: "bankinput",
        component: () => import("../views/bankrupt/bankinput.vue"),
        meta: {
          title: "破产案件录入",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
        hidden: true,
      },
      {
        path: "Bidinput",
        name: "Bidinput",
        component: () => import("../views/bankrupt/Bidinput.vue"),
        meta: {
          title: "破产案件投标录入",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
        hidden: true,
      },
      {
        path: "bankruptdetail",
        name: "bankruptdetail",
        component: () => import("../views/bankrupt/detail.vue"),
        meta: {
          title: "案件信息",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu:'detail',
        },
        hidden: true,
      },
      {
        path: "bankruptfile",
        name: "bankruptfile",
        component: () => import("../views/bankrupt/file.vue"),
        meta: {
          title: "案件文档",
          roles: ["admin", "editor"], // you can set roles in root nav
          menu:'detail',
        },
        hidden: true,
      },
    ],
  },



  //email
  {
    path: "email",
    name: "email",
    component: () => import("../views/email/index.vue"),
    meta: {
      // title: '归档',
      roles: ["admin", "editor"],
    },
  },

  //设置
  {
    path: "set",
    name: "set",
    redirect: "/home/set/menu",
    component: () => import("../views/set/index.vue"),
    meta: {
      title: "设置",
      roles: ["admin", "editor"],
    },
    children: [
    
      {
        path: "organization",
        name: "organization",
        component: () => import("../views/set/organization.vue"),
        meta: {
          title: "组织管理",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      {
        path: "menuManagement",
        name: "menuManagement",
        component: () => import("../views/set/menuManagement.vue"),
        meta: {
          title: "菜单管理",
          roles: ["admin", "editor"], // you can set roles in root nav
        },
      },
      {
        path: "user",
        name: "user",
        component: () => import("../views/set/user.vue"),
        meta: {
          title: "用户管理",
          roles: ["admin", "editor"], // you can set roles in root navu can set ro
        },
      },
    
    ],
  },

];

const router = new VueRouter({
  routes: constantRoutes,
});

export default router;

// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import Login from '../views/Login.vue';
// Vue.use(VueRouter);
// // 获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
//     // 修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

// export const constantRoutes = [{
//         path: '/',
//         redirect: "/login"
//     },
//     {
//         path: "/login",
//         name: "Login",
//         component: Login
//     },
//     {
//         path: "/home",
//         name: 'Home',//home是登录之后的整个首页
//         component: () =>
//             import ("../views/Home.vue"),
//         children: [
//             // 首页默认二级页面
//             {
//                 path: "",
//                 redirect: "homepage"
//             },
//             // 首页
//             {
//                 path: "homepage",
//                 name: "HomePage",//homepage是导航栏中的首页
//                 component: () =>
//                     import ("../views/HomePage/index.vue"),
//                  meta: {
//                     title: '首页',
//                     },
//             },

//         ]

//     }
// ]
// export const asyncRoutes = [{
//         path: "case",
//         component: () =>
//             import ("../views/case/index.vue"),
//         meta: {
//             title: '案例管理',
//             roles: ['admin', 'editor'] // you can set roles in root nav
//         },
//         children: [
//             // 案例默认三级页面
//             {
//                 path: "",
//                 redirect: "my"
//             },
//             // 我的案例
//             {
//                 path: "my",
//                 name: "CaseJoin",
//                 component: () =>
//                     import ("../views/case/my.vue"),
//                 meta: {
//                     title: '我的案例',
//                     roles: ['admin', 'editor'] // you can set roles in root nav
//                 },

//             },
//             // 审批的案例
//             {
//                 path: "commit",
//                 name: "CaseCommit",
//                 component: () =>
//                     import ("../views/case/Commit.vue"),
//                 meta: {
//                     title: '案例审批',
//                     roles: ['admin', 'editor'] // you can set roles in root nav
//                 },
//             },
//             // 所有的案例
//             {
//                 path: "all",
//                 name: "CaseAll",
//                 component: () =>
//                     import ("../views/case/All.vue"),
//                 meta: {
//                     title: '所有案例',
//                     roles: ['admin', 'editor'] // you can set roles in root nav
//                 },
//             },

//         ]
//     },

// ]

// const router = new VueRouter({
//     routes: constantRoutes
// })

// export default router
